import { type FormValues } from '@uturn/portal/modules/shipments/schema';
import {
	addValidationIssue,
	type ValidationResults,
	validationSuccess,
} from '@uturn/portal/types';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export function useShipperReferenceValidation() {
	const { t } = useTranslation();
	/**
	 * If organisation settings state that invoice is required,
	 * then shipperReference is required.
	 *
	 * @param shipperReference
	 * @param invoiceRequired
	 * @param publishing Publishing or updating published shipment
	 * @param validationResults
	 * @returns
	 */
	const validateShipperReference = (
		shipperReference: string,
		invoiceRequired: boolean,
		publishing: boolean,
		validationResults?: ValidationResults<FormValues>,
	): ValidationResults<FormValues> => {
		let results = validationResults ?? validationSuccess;

		if (!publishing || !invoiceRequired) {
			return results;
		}

		const requiredMessage = t(
			'general.errors.form_validation.required',
			'Required.',
		).toString();

		const shipperReferenceSchema = z.string({
			required_error: requiredMessage, // Handles undefined
			invalid_type_error: requiredMessage, // Handles null, non-string
		}).min(1, { message: requiredMessage }); // Handles empty string
		try {
			shipperReferenceSchema.parse(shipperReference);
		} catch (err) {
			if (err instanceof z.ZodError) {
				results = addValidationIssue<FormValues>(
					results,
					err.issues[0].message,
					'shipperReference',
				);
			}
		}

		return results;
	};
	return { validateShipperReference };
}
